@if (steps.length > 1) {
  <ul class="common-stepper__list-no-clickable">
    @for (step of steps | onlyToShow:'wizardSteps'; track $index) {
      <li class="common-stepper__list-item common-stepper__list-item-grow">
        <div class="common-stepper__step-container">
          @if (step.originalStep === state) {
            <div class="common-stepper__button-step common-stepper__button-step--active"
              [attr.disabled]="true">
              <p class="common-stepper__button-text">
                {{step.index}}
              </p>
            </div>
          }
          @if (step.originalStep != state) {
            <div class="common-stepper__button-step"
              [attr.disabled]="true"
              pTooltip="{{step.name}}"
              tooltipPosition="bottom">
              <p class="common-stepper__button-text">
                {{step.index}}
              </p>
            </div>
          }
          <hr class="common-stepper__step-line"
            [ngClass]="step.originalStep !== state? 'common-stepper__step-line-inactive' : 'common-stepper__step-line--active'"/>
        </div>
        @if (step.originalStep === state) {
          <p
            class="common-stepper__step-name">
            {{step.name}}
          </p>
        }
      </li>
    }
  </ul>
}
